var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4254.23,-1.21875 H 0 V 4253.22 H 4254.23 V -1.21875",
    style: {
      fill: "#224b84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 327.309,3740.73 v -150.55 h 1.289 l 101.203,105 h 1.293 v -656.6 h 144.215 v 857.79 H 460.215 L 327.309,3740.73",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 937.156,3232.12 c 0,-54.39 -20.242,-86.01 -69.551,-86.01 -48.07,0 -67.019,32.86 -67.019,86.01 v 156.87 c 2.48,48.07 22.719,78.46 68.309,78.46 49.257,0 68.261,-30.39 68.261,-86.05 z m 142.974,12.63 v 126.53 c 0,140.42 -55.66,211.31 -159.392,211.31 -60.773,0 -97.433,-27.83 -118.914,-69.6 h -1.238 v 184.72 c 0,51.9 16.367,88.58 68.309,88.58 51.843,0 67.023,-30.36 67.023,-83.47 v -57.02 h 131.562 v 45.59 c 0,126.52 -41.72,215.05 -201.164,215.05 -151.804,0 -208.757,-97.4 -208.757,-231.52 v -417.49 c 0,-132.83 58.242,-229 210.046,-229 153.045,0 212.525,83.5 212.525,216.32",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1346.26,3900.05 h 141.5 v -49.28 h -81.08 v -102.81 h 60.41 v -48.76 h -60.41 v -158.44 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1572.03,3850.77 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.8 h -60.41 v 359.29 h 87.96 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.75,-163.22 h -63.58 l -56.71,164.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1713.02,3900.05 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1805.76,3900.05 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2065.45,3590.03 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.44 v -260.74 z m 94.86,213.58 V 3637.2 c 0,-55.11 -22.79,-96.44 -87.44,-96.44 h -93.27 v 359.29 h 93.27 c 64.65,0 87.44,-40.81 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2192.12,3900.05 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2416.84,3766.51 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2634.66,3593.75 -30.73,-81.08 h -33.92 l 7.42,85.85 h 57.23 v -4.77",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1437.42,3232.59 h 85.85 v -191.83 h -43.46 v 39.2 c -7.95,-27.02 -24.91,-43.44 -57.76,-43.44 -51.94,0 -75.79,41.33 -75.79,96.97 v 173.82 c 0,56.18 27.03,96.98 90.62,96.98 66.78,0 86.39,-37.1 86.39,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.48,34.98 -30.21,34.98 -21.72,0 -31.26,-15.37 -31.26,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.6,0 29.67,11.12 29.67,34.44 v 63.6 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1555.08,3400.05 h 144.14 v -49.28 h -83.73 v -102.81 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.27 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1789.33,3350.77 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.8 h -60.41 v 359.29 h 87.96 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.75,-163.22 h -63.58 l -56.71,164.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1930.31,3400.05 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2098.85,3133.49 v 173.82 c 0,56.18 26.5,96.98 90.1,96.98 66.77,0 85.31,-37.1 85.31,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.15,34.98 -21.72,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.97 v 66.25 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.31,-89.56 -63.6,0 -90.1,41.33 -90.1,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2423.19,3199.2 h -58.29 v -158.44 h -60.41 v 359.29 h 60.41 v -152.09 h 58.29 v 152.09 h 60.95 v -359.29 h -60.95 v 158.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2509.07,3400.05 h 160.57 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2695.09,3400.05 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2878.99,3232.59 h 85.85 v -191.83 h -43.46 v 39.2 c -7.95,-27.02 -24.91,-43.44 -57.76,-43.44 -51.94,0 -75.78,41.33 -75.78,96.97 v 173.82 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.1 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.6,0 29.67,11.12 29.67,34.44 v 63.6 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3057.07,3215.63 v -174.87 h -60.42 v 359.29 h 60.42 v -157.92 l 65.71,157.92 h 59.35 l -69.95,-161.63 71.54,-197.66 h -63.59 l -63.06,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3203.88,3400.05 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3377.71,3400.05 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3463.57,3400.05 h 160.57 v -49.28 h -49.81 v -310.01 h -60.95 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1521.67,2900.05 V 2628.2 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1604.37,2766.51 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1846.04,2590.03 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 V 2637.2 c 0,-55.12 -22.78,-96.44 -87.44,-96.44 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.81 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2022.54,2618.13 v 48.22 h 56.17 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.14 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2210.16,2900.05 h 160.57 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2435.93,2654.69 h 48.23 l -23.85,144.14 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.9 l 68.35,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2647.92,2850.77 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.59 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.8 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.76,-163.22 h -63.59 l -56.71,164.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2849.33,2715.63 v -174.87 h -60.42 v 359.29 h 60.42 v -157.92 l 65.71,157.92 h 59.35 l -69.95,-161.63 71.54,-197.66 h -63.59 l -63.06,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2996.14,2900.05 h 144.14 v -49.28 h -83.73 v -102.81 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.27 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1346.26,2400.05 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1489.88,2266.51 v -225.75 h -50.87 v 359.29 h 59.35 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1642.53,2118.13 v 48.22 h 56.17 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 H 1757 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.14 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1830.15,2400.05 h 160.57 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2016.17,2400.05 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2102.03,2400.05 h 160.57 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2463.46,2400.05 V 2128.2 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2488.39,2400.05 h 160.57 v -49.28 h -49.81 v -310.01 h -60.95 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2674.41,2400.05 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2889.58,2123.95 v 192.9 c 0,21.73 -9.55,37.1 -31.27,37.1 -21.2,0 -30.74,-15.37 -30.74,-37.1 v -192.9 c 0,-21.72 9.54,-37.09 30.74,-37.09 21.72,0 31.27,15.37 31.27,37.09 z m -122.42,9.54 v 173.82 c 0,56.18 27.56,96.98 91.15,96.98 64.12,0 91.68,-40.8 91.68,-96.98 v -173.82 c 0,-55.64 -27.56,-96.97 -91.68,-96.97 -63.59,0 -91.15,41.33 -91.15,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3032.68,2266.51 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3188.5,2400.05 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.27 H 3188.5 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3413.21,2266.51 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2672.29,1824.66 c 0,0 -30.71,-40.79 -21.78,-80.52 8.99,-39.75 54.3,-63.39 54.3,-63.39 0,0 30.72,40.79 21.76,80.52 -8.96,39.77 -54.28,63.39 -54.28,63.39",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2622.25,1591.74 c 0,0 30.71,40.81 21.76,80.56 -9,39.76 -54.28,63.35 -54.28,63.35 0,0 -30.75,-40.75 -21.82,-80.51 9.01,-39.74 54.34,-63.4 54.34,-63.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2748.47,1635.42 c 0,0 32.44,-32.71 69.37,-29.42 36.93,3.28 64.3,41.29 64.3,41.29 0,0 -32.38,32.7 -69.35,29.43 -36.93,-3.29 -64.32,-41.3 -64.32,-41.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2801.6,1810.14 c -30.04,-30.5 -25.8,-84.44 -25.8,-84.44 0,0 52.97,-4.59 83.08,25.86 30.04,30.47 25.81,84.42 25.81,84.42 0,0 -53.01,4.59 -83.09,-25.84",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2735.3,1514.17 c 36.8,-4.35 71.41,27.25 71.41,27.25 0,0 -25.06,38.64 -61.83,43 -36.84,4.32 -71.44,-27.29 -71.44,-27.29 0,0 25.06,-38.61 61.86,-42.96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2768.18,922.52 H 2493.1 c -21.53,0 -38.98,-17.36 -38.98,-38.879 0,-21.5 17.45,-38.95 38.98,-38.95 h 275.08 c 21.49,0 38.9,17.45 38.9,38.95 0,21.519 -17.41,38.879 -38.9,38.879",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2768.18,493.57 H 2493.1 c -21.53,0 -38.98,-17.379 -38.98,-38.91 0,-21.469 17.45,-38.922 38.98,-38.922 h 275.08 c 21.49,0 38.9,17.453 38.9,38.922 0,21.531 -17.41,38.91 -38.9,38.91",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1531.02,1017 c -6.47,2.01 -12.87,3.76 -19.1,4.92 0,0 7.05,-2.19 19.1,-4.92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1976.86,848.629 c 18.13,-0.309 36.32,0.23 54.54,1.473 V 706.379 l -54.54,1.242 z m 781.18,-31.109 h -254.91 c -12.22,0 -22.15,-9.938 -22.15,-22.141 v -77.188 l -166.4,-18.293 -243.11,5.551 v 148.5 c 32.29,4.133 64.63,10.571 96.73,19.621 234.02,66.032 285.05,211.79 279.96,345.65 -5.1,136.33 38.53,189.27 101.22,212.82 17.95,6.74 35.7,11 51.96,13.76 0.69,-33.48 7.48,-72.41 22.46,-118.79 5.56,0.3 11.09,0.77 16.59,1.37 -15.81,47.44 -22.56,86.48 -22.93,119.76 32.38,3.83 55.49,1.67 55.49,1.67 0,0 -21.89,11.76 -52.81,37.61 10.51,64.56 48.96,104.2 88.6,144.73 21.78,22.33 44.29,45.35 62.01,72.81 l -13.81,8.91 c -16.77,-26.08 -38.79,-48.5 -59.99,-70.22 -38.65,-39.53 -77.65,-79.93 -90.86,-144.03 -12.56,11.33 -26.15,24.74 -40.05,40.35 -57.71,64.69 -132,17.16 -237.93,-81.47 -106,-98.58 -239.25,-101.96 -369.42,31.22 -171.73,175.8 -321.53,174.81 -424.26,164.83 70.28,-29.94 94.86,-95.6 130.43,-262.5 37.27,-175.14 131.28,-254.37 259.89,-265.31 -59.62,-9.66 -75.08,-17.93 -170.91,-84.12 -74.85,-51.64 -180.13,-35.31 -222.82,-25.62 78.36,-24.43 171.18,-106.621 254.22,-135.23 48.35,-16.641 99.34,-26.93 151.55,-31.071 V 708.551 l -461.13,9.937 V 619.32 l 838.92,18.61 166.4,-18.321 v -77.14 c 0,-12.199 9.93,-22.168 22.15,-22.168 h 254.91 c 12.24,0 22.18,9.969 22.18,22.168 v 252.91 c 0,12.203 -9.94,22.141 -22.18,22.141",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1451.86,635.719 c 0,-20.91 -14.59,-37.867 -32.57,-37.867 h -19.6 c -17.95,0 -32.58,16.957 -32.58,37.867 v 68.543 c 0,20.937 14.63,37.867 32.58,37.867 h 19.6 c 17.98,0 32.57,-16.93 32.57,-37.867 v -68.543",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe16);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-16.75bf99b2b52032b56028f7789dae32cc.svg";
export { ForwardRef as ReactComponent };